module.exports = __webpack_public_path__ + "static/media/csi_team.e6a30035.jpeg";